import "../../utils/tailwind.css";
import { PageProvider, useBlogsProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";
import Tableloader from "../../components/table-loader";
import _ from "lodash";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { getLeadsQuery, handlePageChange, currentPage } = useBlogsProvider();
  if (getLeadsQuery?.isPending) {
    return <Tableloader />;
  }

  const leads = getLeadsQuery?.data?.data?.data?.filter((v) => v.type === "contact-us") || [];
  const paging = getLeadsQuery?.data?.data?.paging || {};

  return (
    <Section className="h-[80vh] overflow-y-auto mt-5">
      <Label className="mb-0 text-black text-[16px] font-semibold" label="Leads" />
      <div className="mt-3 overflow-x-auto mb-10">
        <table className="w-full table-fixed border-collapse border border-gray-300">
          <thead className="bg-gray-200">
            <tr>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[7%]">SR No.</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[10%]">Name</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[14%]">Work Email</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[14%]">Phone</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[8%]">Country</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[15%]">City</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[20%]">Pincode</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[15%]">Query Type</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[15%]">User Type</th>
            </tr>
          </thead>

          <tbody>
            {leads?.map((item, index) => (
              <tr key={index}>
                <td className="border border-gray-300 px-2 py-2 break-words text-center whitespace-normal w-[6%]">
                  <Label className="mb-0 text-black text-[15px]" label={`${index + 1}.`} />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words whitespace-normal w-[10%]">
                  <Label className="mb-0 text-black text-[15px]" label={item.first_name + " " + item.last_name} />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words whitespace-normal w-[30%]">
                  <Label className="mb-0 text-[15px]" label={item.email} />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words whitespace-normal w-[30%]">
                  <Label className="mb-0 text-[15px]" label={item.phone} />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words whitespace-normal w-[15%]">
                  <Label className="mb-0 text-[15px]" label={item.country} />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words whitespace-normal w-[15%]">
                  <Label className="mb-0 text-[15px]" label={item.city} />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words whitespace-normal w-[15%]">
                  <Label className="mb-0 text-[15px]" label={item.pincode} />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words whitespace-normal w-[15%]">
                  <Label className="mb-0 text-[15px]" label={_.startCase(_.toLower(item.queries || "-"))} />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-words whitespace-normal w-[15%]">
                  <Label className="mb-0 text-[15px]" label={_.startCase(_.toLower(item.user_type || "-"))} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="flex justify-end mt-4 pr-4">
          <div className="flex gap-2">
            {Array.from({ length: paging.total_pages || 1 }, (_, i) => i + 1).map((pageNo) => (
              <button
                key={pageNo}
                onClick={() => handlePageChange(pageNo)}
                className={`px-3 py-1 border rounded ${currentPage === pageNo ? "bg-black text-white" : "bg-white text-black"}`}
              >
                {pageNo}
              </button>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}
